export default {
  name: "Notice",
  props: {
    notice: {
      type: Object
    }
  },
  emits: ["notice-click"]
};